import { gql, useQuery } from "@apollo/client";
import { DSP_FIELDS, DspType } from "../../../../../graphql/types/DspType";

export const GET_DSPS_BY_WAREHOUSE_ID = gql`
  query GetDspsByWarehouseId($warehouseId: Long!) {
    dspsByWarehouseId: getDspsByWarehouseId(warehouseId: $warehouseId) {
      ...DspFields
    }
  }
  ${DSP_FIELDS}
`;

interface GetDspsByWarehouseIdResponse {
    dspsByWarehouseId: DspType[];
}

interface GetDspsByWarehouseIdVariables {
    warehouseId: number; // 保持为 number 类型，GraphQL 会自动转换
}

export const useDspsByWarehouseId = (warehouseId: number | null) => {
    const { data, loading, error, refetch } = useQuery<
        GetDspsByWarehouseIdResponse,
        GetDspsByWarehouseIdVariables
    >(GET_DSPS_BY_WAREHOUSE_ID, {
        variables: { warehouseId: warehouseId || 0 },
        skip: warehouseId === null || warehouseId === 0, // 只有当 warehouseId 为 null 或 0 时才跳过
        fetchPolicy: 'cache-and-network',
        errorPolicy: 'all'
    });

    return {
        dspsByWarehouseId: data?.dspsByWarehouseId || [],
        loading,
        error,
        refetch
    };
};
